import React, { useEffect, useRef, useState } from 'react';
import { FaInfoCircle } from 'react-icons/fa';
import { getUUID } from '../../utils/helpers';

const InputFile = ({ file,
    id = '', 
    label = '', 
    handlerFiles,
     part = '', 
     filesCount = undefined, 
     className = '', 
     placeholder = null, 
     isRequired = true,
     info = '' }) => {

    const [data, setData] = useState('');

    let inputRef = useRef();
    let inputRequiredRef = useRef();
    let btnRef = useRef();

    const txtFoto = file != null ? 'Un archivo adjunto' : (placeholder == null ? 'Adjunta Fotografia ' + part : placeholder);

    const hideStyle = {
        height: '0px', width: '0px', overflow: 'hidden'
    }

    const handlerClick = () => inputRef.current.click();

    const handlerChange = obj => {

        proccesFiles(obj.target.files[0]);

    }

    const proccesFiles = _files => {

        btnRef.current.innerHTML = txtFoto;

        handlerFiles(id, _files);

    }

    useEffect(() => {

        if (inputRequiredRef.current) {

            if (file == null)
                inputRequiredRef.current.setCustomValidity('Adjunte un documento');

        }

    }, [data]);

    useEffect(() => {

        proccesFiles(file);

    }, [0]);

    

    return (
        <div className="sg-input mt-15">
            <label htmlFor={id}>{label}
                {info !== '' && <FaInfoCircle color="#E1E1E1" data-tip={info} data-html={true} />}
            </label>
            {(isRequired && file === null ) &&
                <input ref={inputRequiredRef} type="radio" name={getUUID()} className="sg-switch-validator mt-10" />
            }
            <div id={id} className={`yourBtn ${className}`} ref={btnRef} onClick={handlerClick}>{txtFoto}</div>
            <input accept={".png, .jpg, .jpeg"} style={hideStyle} id="upfile" type="file" ref={inputRef} onChange={handlerChange} />
        </div>
    );
}



export default InputFile;
